import { DescriptionCol, DescriptionRow } from '@/components/Description';
import {
  TBusinessDocumentUpload,
  TSetupUploadProps,
} from '@/features/business_documents/UploadForm/Content/type';
import { useDocumentTypeOptions } from '@/features/business_documents/hooks';
import { useTranslation } from '@/i18n';
import { FormSelect, Label } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';

export const DocumentType: FC<TSetupUploadProps> = memo(({ control, name }) => {
  const { t } = useTranslation();

  const options = useDocumentTypeOptions();

  return (
    <DescriptionRow>
      <DescriptionCol
        label={<Label text={t('document_type')} testId='documentTypeLabel' />}
        labelWidth='160px'
      />
      <DescriptionCol
        value={
          <FormSelect<TBusinessDocumentUpload>
            inputId='document-type'
            name={name}
            control={control}
            // eslint-disable-next-line @moneyforward/account-payable/literals-in-props
            selectProps={{ options }}
            // eslint-disable-next-line @moneyforward/account-payable/literals-in-props
            rules={{ required: t('required') }}
            isAllowClearSetToDefaultValue
            testId='documentType'
          />
        }
      />
    </DescriptionRow>
  );
});
DocumentType.displayName = 'DocumentType';
